import React, { useState, useEffect, useRef, useCallback } from "react";
import { DoctorDetails, Map, SearchResultFilter } from "../../components/componentIndex";
import DoctorFour from '../../assets/images/doctor-photo/profile-1.svg';
import DoctorThree from '../../assets/images/doctor-photo/profile-2.svg';
import DoctorTwo from '../../assets/images/doctor-photo/profile-3.svg';
import DoctorOne from '../../assets/images/dashboard/profile-1.svg';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useLocation } from 'react-router-dom';
import NextAvailableBG from '../../assets/images/nextAvailable.svg';
import { Button } from "../../common/commonIndex";
import { useNavigate } from "react-router-dom";
import { useAuthenticationContext } from "services/slices/AuthenticationSlicer";
import PatientService from 'services/API/patientService';
import { debounce } from "lodash";

const SearchResult = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const hash = location.hash;
    const todayDate = new Date();
    const futureDate = new Date();
    futureDate.setDate(todayDate.getDate() + 5);
    const [selectedProviderIndex, setSelectedProviderIndex] = useState(null);
    const [isSearchFilter, setIsSearchFilter] = useState(false);
    const [doctors, setDoctors] = useState([]);
    const [doctorData, setDoctorData] = useState([]);
    const [activeFilter, setActiveFilter] = useState(0);
    const [activeFilterData, setActiveFilterData] = useState({});
    const [genderFilter, setGenderFilter] = useState(null);
    const { state: data } = useAuthenticationContext();
    const [hoveredItem, setHoveredItem] = useState(null);
    const [locationPosition, setLocationPosition] = useState([33.5185892, -86.8103567]);
    const defaultPageNumber = 1;
    const [page, setPage] = useState(defaultPageNumber);
    const [isFetching, setIsFetching] = useState(false);
    const apiBaseUrl = process.env.REACT_APP_IMAGE_URL;
    const popupRef = useRef(null); // Reference for the popup container


    const [tabs, setTabs] = useState([
        { name: 'Colonoscopy', content: 'Colonoscopy Content' },
        // { name: 'Endoscopy', content: 'Endoscopy Content' },
        { name: 'Filter', content: 'Filter Content' }
    ]);

    const searchResultReferringList = [
        {

            NextAvailable: {
                doctorInfo: {
                    name: 'Next Available Provider at Metro Gastroenterology',
                    specialization: 'Gastroenterology',
                    address: '12 slots next week',
                    photo: NextAvailableBG,
                },
                description: 'We’ll match your patient with the first available GI.',
                action: 'Next Available',
            }
        },
        {
            SelectProvider: {
                doctorInfo: {
                    name: 'John Singh, DO',
                    specialization: 'Gastroenterology',
                    address: 'Metro Gastroenterology',
                    rating: '4.5 (54)',
                    photo: DoctorTwo,
                },
                action: 'Select Provider',
            }
        },
        {
            SelectProvider: {
                doctorInfo: {
                    name: 'Evelyn Gross, MD',
                    specialization: 'Gastroenterology',
                    address: 'Carolina Digestive',
                    rating: '4.7 (79)',
                    photo: DoctorThree,
                },
                action: 'Select Provider',
            }
        },
        {
            SelectProvider: {
                doctorInfo: {
                    name: 'Thomas Evans, MD',
                    specialization: 'Gastroenterology',
                    address: 'Northbrook Gastro',
                    rating: '4.8 (234)',
                    photo: DoctorFour,
                },
                action: 'Select Provider',
            }
        }
    ];

    const handleScroll = () => {
        const container = document.querySelector('.search-result-scrollbar');
        if (container.scrollHeight - container.scrollTop <= container.clientHeight + 50 && !isFetching) {
            if (page > 0) {
                debouncedFunction(page);
            }

        }
    };

    const handlePageChange = (pageNumber) => {
        // if (pageNumber === 1 || !pageNumber) {
        //     setDoctors([]); // Clear doctors if we are at the first page
        // }
        if (pageNumber) {
            debouncedFunction(pageNumber);
        }
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        handlePageChange(page || 1);

        if (page > 0) {
            const container = document.querySelector('.search-result-scrollbar');
            if (container) {
                const handleScrollEvent = () => handleScroll(); // Ensure consistent reference for cleanup
                container.addEventListener('scroll', handleScrollEvent);
                return () => container.removeEventListener('scroll', handleScrollEvent);
            }
        }
    }, [location?.search, page]); // Include `page` in dependencies



    const getQueryParamData = () => {
        let searchParam = null; // Use `let` instead of `const` to allow reassignment
        searchParam = window?.location?.search; // Reassign the value
        const queryParams = new URLSearchParams(searchParam);
        const queryObject = {};
        queryParams.forEach((value, key) => {
            queryObject[key] = value === 'null' || value === '' ? null : value;
        });
        return queryObject;
    }

    const getDoctorsWithSlots = async (page) => {
        if (!page) {
            return;
        }

        const queryObject = getQueryParamData();
        try {
            const getDoctorRequest = {
                "fkInsuranceProviderId": queryObject?.insId ? queryObject?.insId : null,
                "latitude": queryObject?.lat ? parseFloat(queryObject?.lat) : 33.5185892,
                "longitude": queryObject?.lng ? parseFloat(queryObject?.lng) : -86.8103567,
                "startDate": queryObject?.startDate ? queryObject?.startDate : null,
                "endDate": queryObject?.endDate ? queryObject?.endDate : null,
                "take": 6,
                "page": page,
                "specialityId": null
            };
            setDoctors([]);
            setIsFetching(true);
            const accessToken = data?.userData?.result?.token;
            const response = await PatientService.getDoctorsWithSlots(getDoctorRequest, accessToken);
            setPage(response.result.nextPage);
            if (response?.statusCode === 200) {
                const transformedDoctors = createDoctorsArray(response?.result?.doctors);
                setDoctors((prevDoctors) => {
                    const uniqueDoctors = [
                        ...prevDoctors,
                        ...transformedDoctors.filter(
                            (newDoctor) => !prevDoctors.some((existingDoctor) => existingDoctor.fkUserId === newDoctor.fkUserId)
                        )
                    ];
                    return uniqueDoctors;
                });
                setDoctorData((prevDoctors) => {
                    const uniqueDoctors = [
                        ...prevDoctors,
                        ...response?.result?.doctors.filter(
                            (newDoctor) => !prevDoctors.some((existingDoctor) => existingDoctor.fkUserId === newDoctor.fkUserId)
                        )
                    ];
                    return uniqueDoctors;
                });
                if (response?.result?.doctors[0]?.latitude && response?.result?.doctors[0]?.longitude) {
                    setLocationPosition([response?.result?.doctors[0]?.latitude, response?.result?.doctors[0]?.longitude]);
                }

            } else {
                setPage(null);
            }
            setIsFetching(false);
        } catch (error) {
            setPage(null);
            setIsFetching(false);
        }
    };

    // const debouncedFunction = debounce((pageNumber) => getDoctorsWithSlots(pageNumber), 200);
    const debouncedFunction = useCallback(debounce((pageNumber) => getDoctorsWithSlots(pageNumber), 200), []);

    useEffect(() => {
        // if(debouncedFunction && page){
        debouncedFunction(page);
        // }
    }, [page, debouncedFunction]);

    const createDoctorsArray = (doctorList) => {
        const transformedDoctors = doctorList?.map((doctor) => {
            if (!doctor?.gender) {
                doctor['gender'] = 'Male';
            }
            // Define doctorProfileUrl outside the returned object
            const doctorProfileUrl = doctor?.profileSignedUrl
                ? !doctor?.profileSignedUrl?.includes('http') ? `${apiBaseUrl}${doctor.profileSignedUrl}` : doctor.profileSignedUrl
                : null;
            return {
                doctorInfo: {
                    name: `${doctor.firstName} ${doctor.lastName}, ${doctor.credential}`,
                    specialization: doctor.specialtyName,
                    address: doctor.surgeryCenterName,
                    rating: doctor.overAllAvgReview ? `${doctor.overAllAvgReview.toFixed(1)} (${doctor.totalReview})` : null,
                    photo: doctorProfileUrl, // Use default photo if profileSignedUrl is null
                    firstName: doctor.firstName,
                    lastName: doctor.lastName,
                    latitude: doctor.latitude,
                    longitude: doctor.longitude,

                    total: doctor.total,
                    fkUserId: doctor.fkUserId,
                    credential: doctor.credential,
                    organizationName: doctor.organizationName,
                    startDate: doctor.startDate,
                    endDate: doctor.endDate,
                    totalReview: doctor.totalReview,
                    overAllAvgReview: doctor.overAllAvgReview
                },
                days: doctor.availableSlots,
            };

        });
        return transformedDoctors;
    }

    const handleAction = (index, value) => {
        // Toggle between showing selected provider and next available
        setSelectedProviderIndex((prevIndex) => (prevIndex === index ? null : index));
        if (value === 'Select Provider') {
            navigate('/referral-form');
        }
    };
    const formatSingleDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Adding 1 since months are 0-indexed
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
    const handleRedirect = (date, item) => {
        // const isoDate = new Date(date); // Converts to ISO format: "2024-11-19T11:32:24.000Z"
        let findDate = formatSingleDate(date);
        let userId = item?.fkUserId;
        const queryParamsStr = "date=" + findDate + "&fkUserId=" + userId;
        navigate(`/doctor-profile${'?' + queryParamsStr}`);
    }
    const openSearchFilterScreen = () => {
        setIsSearchFilter(true);
    };

    const closeSearchFilterScreen = (selectedPracticeData, gender) => {
        setActiveFilterData([]);
        setActiveFilter(0);
        let activeFilter = 0;
        setActiveFilter(0);
        if (selectedPracticeData?.length > 0 && gender) {
            activeFilter = 2;
            setActiveFilter(2);
        } else {
            if (selectedPracticeData?.length > 0 || gender) {
                activeFilter = 1;
                setActiveFilter(1)
            }
        }

        setGenderFilter(gender)
        setActiveFilterData(selectedPracticeData);
        setIsSearchFilter(false);
        filterDoctorList(selectedPracticeData, gender);
    };
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                closeSearchFilterScreen();
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [closeSearchFilterScreen]);

    const filterDoctorList = (selectedPracticeData, gender) => {
        let filteredDoctors = [];
        let searchParam = null; // Use `let` instead of `const` to allow reassignment
        searchParam = window?.location?.search; // Reassign the value
        const queryParams = new URLSearchParams(searchParam); // `searchParam` can now be passed to `URLSearchParams`
        const queryObject = {}; // Object to store query parameters
        // Loop through query parameters and build the queryObject
        queryParams.forEach((value, key) => {
            queryObject[key] = value === 'null' || value === '' ? null : value;
        });

        filteredDoctors = doctorData?.filter((doctor) => {
            const doctorPractice = doctor.organizationName;
            const doctorGender = doctor.gender;
            if (selectedPracticeData?.length > 0 && gender) {
                // Both selectedPracticeData and gender filters are applied
                return selectedPracticeData.includes(doctorPractice) && doctorGender === gender;
            } else if (selectedPracticeData?.length > 0) {
                // Only selectedPracticeData filter is applied
                return selectedPracticeData.includes(doctorPractice);
            } else if (gender) {
                // Only gender filter is applied
                return doctorGender === gender;
            }
            // If no filters are provided, include all doctors
            return true;
        });
        const doctorArray = createDoctorsArray(filteredDoctors);
        setDoctors(doctorArray);
    }

    const handleMouseEnter = (index) => {
        setHoveredItem(index); // Set the hovered item index
    };

    const handleMouseLeave = () => {
        setHoveredItem(null); // Reset when mouse leaves
    };

    const getDayName = (date) => {
        if (date) {
            // Parse the date as UTC to avoid timezone issues
            const formattedDate = new Date(date);
            if (!isNaN(formattedDate)) {
                // Force the date to be interpreted in UTC
                const utcDayName = formattedDate.toLocaleDateString("en-US", {
                    weekday: "short",
                    timeZone: "UTC", // Ensures correct day calculation
                });
                return utcDayName;
            } else {
                console.error("Invalid date format:", date);
                return null;
            }
        }
        return null;
    };
    
    const getDayNumber = (date) => {
        // Get the day number (e.g., "09")
        if (date) {
            const findDate = new Date(date);
            return findDate.getUTCDate();
        }
    }

    return (
        <>
            <Tabs>
                <div className="search-result-content container-fluid">
                    <TabList className={'filter-content'}>
                        {tabs.map((tab, index) => (
                            <Tab key={index} className={`filter-${tab.name.toLowerCase()}`} onClick={tab.name.toLowerCase() === 'filter' ? openSearchFilterScreen : null}>
                                {tab.name}
                                {tab.name.toLowerCase() === 'filter' && (
                                    <>
                                        {activeFilter !== 0 && activeFilter && (
                                            <div className="active-filter">
                                                <span className="badge badge-primary">{activeFilter}</span>
                                            </div>
                                        )}
                                    </>
                                )}
                            </Tab>
                        ))}

                    </TabList>
                </div >
                <div className="divider"></div>
                {tabs.map((tab, index) => (
                    <TabPanel key={index}>
                        <div className="search-result-content container-fluid">
                            <div className="row ">
                                <div className="col-lg-7 pe-0">
                                    {hash === '#Patient' || !hash || hash === '#' ? (
                                        <div className="scrollbar search-result-scrollbar">
                                            <div className="force-overflow">
                                                {doctors?.length > 0 ? (
                                                    doctors.map((item, index) => (
                                                        <div className="row" key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={handleMouseLeave}>
                                                            <div className="col-md-6 pe-lg-0">
                                                                <div className="slot-list" onClick={() => handleRedirect(item?.days[0]?.date, item?.doctorInfo)}>
                                                                    <DoctorDetails doctorInformation={item?.doctorInfo} />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="slots slot-scroll">
                                                                    <div className={`${item?.days?.length > 0 ? 'd-flex justify-content-start align-items-start' : 'd-flex justify-content-center align-items-center h-194 not-found-txt'}`}>
                                                                        {item?.days?.length > 0 ? (
                                                                            item?.days?.map((day, index) => (
                                                                                <div className={`slot-day ${day?.slots?.length === 0 ? 'slot-day-no' : ''}`} key={index}>
                                                                                    <div>
                                                                                        <p className="day-name mb-0">{day?.date ? getDayName(day?.date) : ''}</p>
                                                                                        <p className="day-number mb-0">{day?.date ? getDayNumber(day?.date) : '-'}</p>
                                                                                    </div>
                                                                                    <div className={`slot-item ${day?.slots?.length > 0 ? '' : 'no-drop'}`} onClick={day?.slots?.length > 0 ? () => handleRedirect(day.date, item?.doctorInfo) : null}>
                                                                                        <p className="slot-number">{day?.slots?.length > 0 ? day?.slots?.length : '-'}</p>
                                                                                        <p className="slot-name">{day?.slots?.length > 0 ? 'slots' : 'no slots'}</p>
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <p>No slots</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <>
                                                        {isFetching ? <div className="loader"></div> : <div className="content pt-3">No doctor in search criteria</div>}
                                                    </>
                                                )}
                                                {isFetching && doctors?.length > 0 ? <div className="loader"></div> : ''}
                                            </div>
                                        </div>

                                    ) : hash === '#Referring' && (
                                        <div className="scrollbar search-result-scrollbar referring-scroll">
                                            <div className="force-overflow">
                                                <div className="search-result-referring ">
                                                    {searchResultReferringList?.length > 0 ? (
                                                        searchResultReferringList?.map((item, index) => (
                                                            <div className={`row ${index === 0 ? 'next-available ms-0' : ''} `} key={index}>
                                                                <div className={item?.NextAvailable?.doctorInfo ? 'col-md-6 ps-0' : 'col-sm-8 col-md-9 col-lg-8 col-xl-9 slot-xl-9-width'}>
                                                                    <div className={`slot-list ${item?.NextAvailable?.doctorInfo ? 'm-0' : ''}`}>
                                                                        <DoctorDetails doctorInformation={
                                                                            item?.NextAvailable?.doctorInfo
                                                                                ? item?.NextAvailable?.doctorInfo
                                                                                : item?.SelectProvider?.doctorInfo
                                                                        } />
                                                                    </div>
                                                                </div>
                                                                {item?.NextAvailable?.description && (
                                                                    <div className="col-sm-8 col-md-3">
                                                                        <div className="justify-content-center h-100">
                                                                            <p className="next-availab-description mb-0">
                                                                                {item?.NextAvailable?.description}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <div className={item?.NextAvailable?.description ? 'col-sm-4 col-md-3 ' : 'col-sm-4 col-md-3 col-lg-4 col-xl-3 slot-xl-3-width'}>
                                                                    <div className={`h-100 ${window.innerWidth > 768 ? 'justify-content-center' : 'd-flex justify-content-end'}`}>
                                                                        <Button btnClass={'btn btn-primary question-btn'}
                                                                            btnName={
                                                                                item?.NextAvailable?.description
                                                                                    ? item?.NextAvailable?.action
                                                                                    : item?.SelectProvider?.action}
                                                                            btnType={'button'}
                                                                            isDisabled={true}
                                                                            onClick={() => handleAction(index, item?.NextAvailable?.action
                                                                                ? item?.NextAvailable?.action
                                                                                : item?.SelectProvider?.action)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <p>No results found.</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="col-lg-5 ps-0 pe-0">
                                    <div className="mt-4 mt-lg-0">
                                        {doctors?.length > 0 ? (
                                            <Map position={locationPosition} doctors={doctors} isSearchResult={true} hoveredItem={hoveredItem} />
                                        ) : (
                                            <Map position={locationPosition} isSearchResult={true} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                ))}

            </Tabs>

            {isSearchFilter && (
                <div className="fullscreen-overlay">
                    <div className="fullscreen-overlay-content search-result-filter" ref={popupRef}>
                        <SearchResultFilter closeSearchFilterScreen={closeSearchFilterScreen} doctors={doctorData} activeFilterData={activeFilterData} genderFilter={genderFilter} />
                    </div>
                </div>
            )
            }
        </>
    )
};

export default SearchResult;